<template>
  <div class="columns program-item">
    <div class="column is-3-widescreen is-3-tablet is-4-desktop">
      <div class="program-item__time">
        <div class="program-item__time__from">
          <p>{{ withoutSeconds(from) }}</p>
        </div>
        <div class="program-item__time__progress">
          <progress
            class="progress is-primary is-small"
            :value="progressValue"
            max="100"
          />
        </div>
        <div class="program-item__time__to">
          <p>{{ withoutSeconds(to) }}</p>
        </div>
      </div>
    </div>
    <div
      class="column program-item__title"
      :class="{ 'has-text-primary': state === 'playing' }"
    >
      {{ title }}
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";

import { linear } from "%utils/math";

export default {
  name: "program-item",

  props: {
    title: String,
    from: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    },
    current: {
      type: dayjs,
      required: true
    },
    now: {
      type: dayjs,
      required: true
    }
  },

  computed: {
    progressValue() {
      return Math.floor(
        linear({ x: this.fromDate, y: 0 }, { x: this.toDate, y: 100 })(this.now)
      );
    },

    day() {
      return this.current.format("YYYY-MM-DD");
    },

    fromDate() {
      return dayjs(`${this.day} ${this.from}`);
    },

    toDate() {
      return dayjs(`${this.day} ${this.to}`);
    },

    state() {
      return this.now < this.fromDate
        ? "pending"
        : this.fromDate <= this.now && this.now <= this.toDate
        ? "playing"
        : "gone";
    }
  },

  methods: {
    withoutSeconds(hourString) {
      return hourString.substr(0, 5);
    }
  }
};
</script>

<style lang="scss" scoped>
.program-item {
  padding: 0.5rem 0;

  &:not(:last-of-type) {
    border-bottom: solid 1px $white-ter;
  }

  &__time {
    font-family: $family-sans-serif-wide;
    display: flex;
    user-select: none;

    &__from {
      display: inline-block;
      vertical-align: middle;
      width: 3rem;
      text-align: right;
    }

    &__to {
      display: inline-block;
      vertical-align: middle;
      width: 3rem;
      text-align: left;
    }

    &__progress {
      display: inline-block;
      vertical-align: middle;
      width: 6rem;
      text-align: center;
      padding: 0 0.5rem;

      progress {
        display: inline-block;
        vertical-align: middle;
        width: 100%;
      }
    }
  }

  &__title {
    font-family: $family-sans-serif-wide;
    vertical-align: middle;
    margin: 0;

    @include mobile {
      padding-top: 0;
    }
  }
}
</style>
